import React, {useEffect, useState} from "react";
import PropTypes from 'prop-types';
import makeStyles from "@material-ui/core/styles/makeStyles";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";
import Typography from "@material-ui/core/Typography";
import JsonScreenHoc from "../../../../../../HocHelpers/JsonScreenHoc";

const useStyles = makeStyles(() => ({
    container: {
        padding: 10,
        marginTop: 2,
        display: 'flex'
    },
    actionButton: {
        display: 'flex',
        alignItems: 'center',
        margin: "0 10px"
    },
    likeCount: {
        '&:hover': {
            textDecoration: 'underline',
            cursor: 'pointer'
        }
    }
}));

const FeedFooter = ({like = [], comments = [], onClickLikeNumber, userId, openFeedPost, onClickLike}) => {
    const classes = useStyles();
    const [isActive, setIsActive] = useState(false);
    useEffect(() => {
        const findForUser = like.find(l => l === userId);
        setIsActive(Boolean(findForUser))
    }, [like.length]);

    return (
        <div className={classes.container}>
            <LikeButton
                icon={isActive ? "thumb_up" : "thumb_up_off_alt"}
                onClick={onClickLike}
                count={like.length}
                onClickLikeNumber={onClickLikeNumber}
            />
            <ActionButton
                icon={"chat_bubble_outline"}
                onClick={openFeedPost}
                count={comments.length}
            />
        </div>
    )
};

export default JsonScreenHoc(FeedFooter)

FeedFooter.propTypes = {
    like: PropTypes.array,
    comments: PropTypes.array,
    onClickLikeNumber: PropTypes.func
};

export const ActionButton = ({icon, count, onClick}) => {
    const classes = useStyles();
    return (
        <div className={classes.actionButton}>
            <IconButton style={{padding: 3}} onClick={onClick}>
                <Icon>
                    {icon}
                </Icon>
            </IconButton>
            {count > 0 && (
                <Typography color={"textSecondary"}>
                    {count}
                </Typography>
            )}
        </div>
    )
};

export const LikeButton = ({onClick, onClickLikeNumber, icon, count}) => {
    const classes = useStyles();
    return (
        <div className={classes.actionButton}>
            <IconButton style={{padding: 3}} onClick={onClick}>
                <Icon>
                    {icon}
                </Icon>
            </IconButton>
            {count > 0 && (
                <Typography color={"textSecondary"} className={classes.likeCount} onClick={onClickLikeNumber}>
                    {count}
                </Typography>
            )}
        </div>
    )
};